<div class="panel panel-default">
        <h2 mat-dialog-title>You can edit of your day schedule</h2>
        <div class="panel-body">
        <form class="form-horizontal"  *ngIf=data>
        
        <div class="form-group">
          <label for="day" class="col-sm-4 control-label">Selected Day: </label>
          <div class="col-sm-9">
            <input type="text" class="form-control" [(ngModel)]="data.day" name="day" id="day" disabled>
          </div>
        </div>
        <div class="form-group">
          <label for="stime" class="col-sm-4 control-label">Start Time </label>
          <div class="col-sm-9">
            <input type="time" class="form-control" [(ngModel)]="data.stime" name="stime" id="stime">
          </div>
        </div>
        <div class="form-group">
                <label for="etime" class="col-sm-4 control-label">End Time </label>
                <div class="col-sm-9">
                  <input type="time" class="form-control" [(ngModel)]="data.etime" name="etime" id="etime">
                </div>
              </div>
              <div class="form-group">
                    <label for="sd" class="col-sm-4 control-label">Slot Duration </label>
                    <div class="col-sm-9">
                      <input type="number" class="form-control" [(ngModel)]="data.sduration" name="sd" id="sd">
                    </div>
                  </div>
                  <button class="btn btn-success2" (click)="editMySchedule()">Confirm</button>
                  <button class="btn btn-success">Cancel</button>
    </form>
    </div>


      